import { parseHeDataLogFile, calcXRangeOfAvailableDays } from "./util/HeDataLogFiles"

export const FETCH_HEDATA_LOGS_LIST_REQUESTED = "FETCH_HEDATA_LOGS_LIST_REQUESTED";
export const FETCH_HEDATA_LOGS_LIST_SUCCEEDED = "FETCH_HEDATA_LOGS_LIST_SUCCEEDED";
export const FETCH_HEDATA_LOGS_LIST_FAILED = "FETCH_HEDATA_LOGS_LIST_FAILED";
export const FETCH_HEDATA_LOG_FILE_REQUEST = "FETCH_HEDATA_LOG_FILE_REQUEST";
export const FETCH_HEDATA_LOG_FILE_SUCCEEDED = "FETCH_HEDATA_LOG_FILE_SUCCEEDED";
export const FETCH_HEDATA_LOG_FILE_FAILED = "FETCH_HEDATA_LOG_FILE_FAILED";
export const FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST = "FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST";
export const FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED = "FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED";
export const FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED = "FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED";

export const PURPOSE_LOG_VALUES = "FETCH_FILES_FOR_LOG_VALUES"
export const PURPOSE_DAILY_VALUES = "PURPOSE_DAILY_VALUES"
export const PURPOSE_ENERGY_BALANCE_CSV = "PURPOSE_ENERGY_BALANCE_CSV"
export const PURPOSE_ENERGY_BALANCE_PDF = "PURPOSE_ENERGY_BALANCE_PDF"

export const requestStateNone = "No Request"
export const requestStatePending = "Request pending"
export const requestStateSucceeded = "Request succeeded"
export const requestStateFailed = "Request failed"

export const fetchHeDataLogsListRequestAction = () => ({
		type: FETCH_HEDATA_LOGS_LIST_REQUESTED
})

export const fetchHeDataLogsListSucceededAction = () => ({
	type: FETCH_HEDATA_LOGS_LIST_SUCCEEDED
})

export const fetchHeDataLogsListFailedAction = () => ({
	type: FETCH_HEDATA_LOGS_LIST_FAILED
})

export const fetchHeDataLogFileRequestAction = (availableDaysIndex) => ({
	type: FETCH_HEDATA_LOG_FILE_REQUEST,
	index: availableDaysIndex
})

export const fetchHeDataLogFileSucceedAction = (availableDaysIndex, fileContent) => ({
	type: FETCH_HEDATA_LOG_FILE_SUCCEEDED,
	index: availableDaysIndex,
	file: fileContent
})

export const fetchHeDataLogFileFailedAction = (availableDaysIndex) => ({
	type: FETCH_HEDATA_LOG_FILE_FAILED,
	index: availableDaysIndex
})

export const fetchMultipleHeDataLogFilesRequestAction = (requestedListOfFiles, purpose, requiredData) => ({
	type: FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST,
	requestedFiles: requestedListOfFiles,
	purpose: purpose,
	requiredData: requiredData
})

export const fetchMultipleHeDataLogFilesSucceededAction = (purpose, requiredData) => ({
	type: FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED,
	purpose: purpose,
	requiredData: requiredData
})

export const fetchMultipleHeDataLogFilesFailedAction = () => ({
	type: FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED
})

const initialState = {
	requestState: requestStateNone,
	sortedListOfAvailableDays: [],
	xrange: []
}

export const fetchHeDataLogsListReducer = (state = initialState, action) => {
	switch(action.type) {
	case FETCH_HEDATA_LOGS_LIST_REQUESTED:
		console.log("FETCH_HEDATA_LOGS_LIST_REQUESTED")
		return state;

	case FETCH_HEDATA_LOGS_LIST_SUCCEEDED:
		console.log("FETCH_HEDATA_LOGS_LIST_SUCCEEDED")
		return {
			...state,
			sortedListOfAvailableDays: [...action.sortedListOfAvailableDays],
			xrange: calcXRangeOfAvailableDays(action.sortedListOfAvailableDays)
		}

	case FETCH_HEDATA_LOGS_LIST_FAILED:
		console.log("FETCH_HEDATA_LOGS_LIST_FAILED")
		return {
			...state,
			sortedListOfAvailableDays: [],
			xrange: []
		}

	case FETCH_HEDATA_LOG_FILE_REQUEST:
		console.log("FETCH_HEDATA_LOG_FILE_REQUEST")
		return state;

	case FETCH_HEDATA_LOG_FILE_SUCCEEDED:
		console.log("FETCH_HEDATA_LOG_FILE_SUCCEEDED")
		if(action.fileContent == null) {
			return state
		}
		else {
			let newState = {...state};
			const parsedCsvFile = parseHeDataLogFile(action.fileContent)
			newState.sortedListOfAvailableDays[action.index].file = {...parsedCsvFile}
			return newState
		}

	case FETCH_HEDATA_LOG_FILE_FAILED:
		console.log("FETCH_HEDATA_LOG_FILE_FAILED: message:")
		console.log(action.message)
		return state;

	case FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST:
		console.log("FETCH_MULTIPLE_HEDATA_LOG_FILES_REQUEST")
		return {
			...state,
			requestState: requestStatePending
		}

	case FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED:
		console.log("FETCH_MULTIPLE_HEDATA_LOG_FILES_SUCCEEDED")
		return {
			...state,
			requestState: requestStateSucceeded
		}

	case FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED:
		console.log("FETCH_MULTIPLE_HEDATA_LOG_FILES_FAILED")
		return {
			...state,
			requestState: requestStateFailed
		}

	default:
		return state;
	}
}